const state= {};
const getters = {};
const actions = {
    async getItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/debtor-creditor`, { params: params })
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    }
}

const mutations = {};
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
